import {
  API_REQUEST,
  ACTIVATE_TOTP_URL,
  VERIFY_CODE_TOTP_URL,
  MFA_GET_STATUS,
  DELETE_TOTP_URL,
  RESEND_RECOVERY_CODE_EMAIL_URL,
  VERIFY_CODE_EMAIL_URL,
} from 'constants/ApiConstants';
import {
  ACTIVATE_TOTP,
  ACTIVATE_TOTP_LOGIN,
  VERIFY_CODE_TOTP,
  VERIFY_CODE_TOTP_LOGIN,
  VERIFY_CODE_EMAIL_PERFIL,
  MFA_RESET,
  FETCH_MFA,
  DELETE_TOTP,
  RESEND_RECOVERY_CODE_EMAIL,
  VERIFY_CODE_EMAIL_LOGIN,
  VERIFY_CODE_EMAIL_LOGIN_UUID,
} from 'constants/ActionTypes';
import Auth from 'utils/Auth';

export const TOTPActivate = (enforce = false) => ({
  type: API_REQUEST,
  payload: {
    url: ACTIVATE_TOTP_URL,
    method: 'post',
    next: enforce ? ACTIVATE_TOTP_LOGIN : ACTIVATE_TOTP,
  },
});

export const TOTPVerifyCode = (id, code, enforce = false) => ({
  type: API_REQUEST,
  payload: {
    url: VERIFY_CODE_TOTP_URL(id),
    method: 'post',
    data: {
      code,
    },
    next: enforce ? VERIFY_CODE_TOTP_LOGIN : VERIFY_CODE_TOTP,
  },
});

export const EmailVerifyCode = (id, code, perfil = false, uuid = null) => ({
  type: API_REQUEST,
  payload: {
    url: VERIFY_CODE_EMAIL_URL(id),
    method: 'post',
    data: {
      code,
      uuid,
    },
    // eslint-disable-next-line no-nested-ternary
    next: uuid
      ? VERIFY_CODE_EMAIL_LOGIN_UUID
      : perfil
      ? VERIFY_CODE_EMAIL_PERFIL
      : VERIFY_CODE_EMAIL_LOGIN,
  },
});

export const MFAResetErrors = () => ({
  type: MFA_RESET,
});

export const fetchMFA = (id = Auth.getInstance().getUserId()) => ({
  type: API_REQUEST,
  payload: {
    url: MFA_GET_STATUS(id),
    method: 'get',
    next: FETCH_MFA,
  },
});

export const deleteTOTP = id => ({
  type: API_REQUEST,
  payload: {
    url: DELETE_TOTP_URL(id),
    method: 'delete',
    next: DELETE_TOTP,
  },
});

export const resendRecoveryCodeEmail = token => ({
  type: API_REQUEST,
  payload: {
    data: {
      token,
    },
    url: RESEND_RECOVERY_CODE_EMAIL_URL,
    method: 'post',
    next: RESEND_RECOVERY_CODE_EMAIL,
  },
});
